import React, { useEffect, useRef } from 'react';
import { CheckCircle2, CircleHelp, Image, Lightbulb, Star, XCircle } from 'lucide-react';
import { Button } from '../ui/button';

export const FusedQuizStep = ({ state, busy, onAnswer, onReference }) => {
  const q = state.question;
  const feedbackRef = useRef(null);
  const isReview = state.view_index < state.current_index;
  useEffect(() => {
    if (state.solved || state.tip) feedbackRef.current?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }, [state.solved, state.tip]);
  return <section className="fp-quiz fp-enter" data-testid="fused-question">
    <div className="fp-question-meta">
      <span className="fp-eyebrow" data-testid="fused-question-id"><CircleHelp size={16} />REACTIVO {q.id_paso} · MASTERCLASS</span>
      {q.es_perla_final && <span className="fp-pearl" data-testid="fused-question-pearl"><Star size={14} />Perla de consolidación</span>}
    </div>
    <h2 className="fp-question-stem" data-testid="fused-question-stem">{q.enunciado}</h2>
    <Button variant="ghost" className="fp-reference-button" onClick={onReference} data-testid="fused-revisit-slide"><Image size={17} />Revisar diapositiva {state.step.page}</Button>
    <div className="fp-options" role="group" aria-label="Opciones de respuesta">
      {'ABCD'.split('').map(letter => {
        const correct = state.solved && letter === state.correct_option;
        const wrong = state.attempted_options.includes(letter) && !correct;
        return <button type="button" key={letter} data-testid={`fused-option-${letter.toLowerCase()}`} disabled={busy || state.solved || wrong || isReview} onClick={() => onAnswer(letter)}
          className={`fp-option ${correct ? 'fp-correct' : wrong ? 'fp-wrong' : ''}`} aria-label={`${letter}. ${q[`opcion_${letter.toLowerCase()}`]}`}>
          <span className="fp-option-letter" aria-hidden="true">{letter}</span><span>{q[`opcion_${letter.toLowerCase()}`]}</span>
          {correct ? <CheckCircle2 className="fp-option-icon" size={20} /> : wrong ? <XCircle className="fp-option-icon" size={20} /> : null}
        </button>;
      })}
    </div>
    <div ref={feedbackRef} aria-live="polite" aria-atomic="true">
      {!state.solved && state.tip && <div className="fp-feedback fp-rescue" role="status" data-testid="fused-rescue-tip">
        <h3 data-testid="fused-rescue-title"><Lightbulb size={20} />Pista de rescate</h3><p>{state.tip}</p><span className="fp-source-note">Pista original del CSV</span>
      </div>}
      {state.solved && <div className="fp-feedback fp-success" role="status" data-testid="fused-explanation">
        <h3 data-testid="fused-answer-result"><CheckCircle2 size={20} />{state.attempted_options.length === 1 ? 'Correcto al primer intento' : 'Resuelto con apoyo'}</h3>
        <p data-testid="fused-feedback-text">{state.feedback}</p>
      </div>}
    </div>
  </section>;
};